import { env, apimKey } from "../../../config";
import log from "../../../utils/log";

export default async function createOrderAsync(params) {
  log("createOrderAsync", "request", params);

  const baseUrl = `https://apim-ikeasa.azure-api.net/CreateOrder/${env}/v2/`;
  const response = await fetch(baseUrl, {
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimKey,
    },
    method: "post",
    body: JSON.stringify(params),
  });

  if (response.status === 200) {
    const json = await response.json();
    log("createOrderAsync", "response", json);

    return json;
  }

  throw new Error(response.status);
}

/**
 * Sample input:
 * {
      First_Name: "Hamed",
      Last_Name: "Alkaf",
      Post_Code: "21001", // district.Code
      Mobile_No: "0567067006",
      Email: "hamed.alkaf@ikea.com.sa",
      TMS_Id: "TMS_123_45446",
      TMS_Date: "2020-05-15T00:00:23.709Z",
      Customer_Address: "Rehab Jeddah",
      CityId: "1",
      DistrictId: "11001",
      Serivce_ID: "1000001",
      Payment_Brand: "",
      Card_No: "",
      Card_Expiry: "12/20",
      Service_Type: "Store", // service.Service_Type
      Created_On: "2020-05-15T00:00:23.709Z",
      Agent_Code: "CO-MEA",
      NAV_Item_No: "99999999", // service.NAV_Item_No
      Order_Type: "CO", // service.Order_Type
      TMS_Start_Time: "2020-05-15T00:00:23.709Z",
      TMS_End_Time: "2020-05-15T00:00:23.709Z",
      Store_No: "197",
    }

 * Sample response:
 * {OrderId: "100000013", RequestCreatedOn: "2020-09-09T08:24:05.5130000", Status: "Created"}
*/
